export const FACE = {
  title: 'Créer une face',
  titleModification: 'Modifier face',
  code: 'Code',
  motifNonCommercialisation: 'Motif de non commercialisation',
  etat: 'Etat',
  faces: 'Faces',
  dateMontage: 'Date de montage',
  proposableLc: 'Proposable en LC',
  proposableReseau: 'Proposable en réseau',
  dateDemontage: 'Date de démontage',
  declarableMairie: 'Déclarable en mairie',
  ajouterFace: 'Ajouter une face',
  irreversible: 'La suppression d\'une face est irréversible.',
  delete: 'Etes-vous sûr de vouloir supprimer cette face ?',
  oldReference: 'Ancienne référence',
  information: 'Informations',
  yes: 'Oui',
  no: 'Non',
  etatListe: {
    aDemonte: 'A démonter',
    aMonter: 'A monter',
    demonte: 'Démonté',
    monte: 'Monté',
    enCoursMontage: 'En cours de montage',
    enCoursDemontage: 'En cours de démontage',
    enCoursDeFabrication: 'En cours de fabrication',
    fabrique: 'Fabriqué',
    archive: 'Archivé',
  },
};

export const DETAIL_FACE = {
  title: 'Détail face {code}',
  detailWithoutCode: 'Détail face',
  faceArchive: 'Face archivée',
  tab: {
    infoGenerale: 'Information générale',
    listeOt: 'OT technique',
  },
  actions: {
    annuler: 'Retour',
    edit: 'Modifier',
    remplacer: 'Remplacer le produit',
  },
  carrac: {
    title: 'Caractéristiques',
    code: 'Code :',
    commericalisable: 'Commercialisable :',
    declarableMairie: 'Déclarable en mairie :',
    proposableLc: 'Proposable en LC :',
    proposableReseau: 'Proposable en réseau :',
  },
  pj: {
    title: 'Pièces jointes',
  },
  titleAccesRapide: 'Accès rapide',
  seeProduct: 'Voir le produit',
  voirListeAffichage: 'Voir la liste d\'affichage',
  error: {
    deleteImpossible: 'Suppression impossible',
    remlacementImpossible: 'Remplacement impossible',
  },
  archivageDesarchiver: {
    archivage: 'Etes-vous sûr de vouloir archiver cette face ?',
    desarchivage: 'Etes-vous sûr de vouloir désarchiver cette face ?',
  },
  supprimerFace: 'Etes-vous sûr de vouloir supprimer la face {code}?',
  messages: {
    success: {
      archivage: 'Face archivée avec succès.',
      desarchivage: 'Face désarchivée avec succès.',
    },
    error: {
      faceEtatDiffDemonte: 'La face ne peut-être archivée que si son état de montage est à "démonté"',
      forbiddenUpdateFaceArchive: 'Impossible de modifier les informations d\'une face archivée',
      desarchivageImpossible: 'La face ne peut-être désarchivée que si son matériel est désarchivé',
    },
  },
  steps: {
    caracteristiques: 'Caractéristiques',
    montage: 'Montage / démontage',
    pj: 'Pièces jointes',
  },
};

export const LISTE_FACE = {
  title: 'Liste des faces',
  actions: {
    search: 'Rechercher',
    edit: 'Modifier',
    editionDiaporama: 'Diaporama',
    exportCA: 'Export avec chiffres d\'affaires',
    archiverFace: 'Archiver',
    desarchiverFace: 'Désarchiver',
  },
  tab: {
    codeMateriel: 'Code matériel',
    codeFace: 'Code face',
    disposition: 'Disposition',
    format: 'Format',
    typeMateriel: 'Type de matériel',
    typeDispositif: 'Type de dispositif',
    support: 'Support',
    etatMontage: 'Etat montage',
    adresse: 'Adresse',
    agence: 'Agence',
    affectation: 'Affectation(s)',
    multiple: 'Multi-affectation',
    archive: 'Archivée',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    nonCommercialisable: 'Non commercialisable',
    code: 'Code(s)',
    codeFace: 'Code(s) face',
    codeBail: 'Code(s) bail',
    codeMateriel: 'Code(s) matériel',
    proposableLc: 'Proposable en LC',
    proposableReseau: 'Proposable en réseau',
    avecCoordonnees: 'Avec coordonées',
    format: 'Format(s)',
    typeMateriel: 'Type(s) de matériel',
    typeDispositif: 'Type(s) de dispositif',
    typeSupport: 'Type(s) de support',
    etat: 'Etat(s)',
    adresse: 'Adresse',
    ville: 'Ville(s)',
    au: ' au ',
    agglomerations: 'Agglomération(s)',
    departements: 'Département(s)',
    dateMontage: 'Date de montage',
    dateDemontage: 'Date de démontage',
    yes: 'Oui',
    no: 'Non',
    actif: 'Actif',
    eclaire: 'Eclairé',
    motifNonCommercialisation: 'Motif(s) de non commercialisation',
    codePostal: 'Code(s) postal',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  errors: {
    faceUsedInNCircuits: 'Face {code} utilisée dans {qte} tournée(s)',
    faceUsedInNContracts: 'Face {code} utilisée par des échéances de {qte} Contrat(s) de bail',
    faceUsedInNetwork: 'Face {code} utilisée dans le réseau {libelle} ({codeReseau})',
    faceUsedInNNetworks: 'Face {code} utilisée dans {qte} réseau(x)',
    faceUsedInNPurchaseBills: 'Face {code} utilisée dans {qte} facture(s) d\'achat',
    faceUsedInNPurchaseOrders: 'Face {code} utilisée dans {qte} commande(s) d\'achat',
    faceUsedInNSellBills: 'Face {code} utilisée dans {qte} facture(s) de vente',
    faceUsedInNSellOrders: 'Face {code} utilisée dans {qte} commande(s) de vente',
    faceUsedInNSellQuotes: 'Face {code} utilisée dans {qte} devis de vente',
    faceUsedInNOtTech: 'Face {code} utilisée dans {qte} OT(s) technique',
    faceUsedInNDispositifProduct: 'Face {code} est sur liée au produit dispositif vendu dans la commande {cmde}',
    faceUsedInNWeekFaceCircuits: 'Face {code} utilisée en logistique dans {qte} tournée(s) entre les semaines {minAnneeSemaine} et {maxAnneeSemaine}',
    faceUsedIn1WeekFaceCircuits: 'Face {code} utilisée en logistique dans une tournée a la semaines {anneeSemaine}',
    faceUsedInLogisticRequest: 'Face {code} utilisée dans {qte} demande(s) d\'intervention(s)',
    noActionSelect: 'Aucune action sélectionnée',
    exportCA: {
      title: 'Export avec chiffres d\'affaires impossible',
      parametre: 'Action interdit, veuillez contacter le support',
    },
  },
  supprimer: {
    titre: 'Etes-vous sûr de vouloir supprimer cette face ?',
  },
  archivageDesarchiver: {
    archivage: 'Etes-vous sûr de vouloir archiver cette face ?',
    desarchivage: 'Etes-vous sûr de vouloir désarchiver cette face ?',
  },
  titleSupprimer: 'Etes-vous sûr de vouloir supprimer la face {code}?',
  messages: {
    success: {
      archivage: 'Face archivée avec succès.',
      desarchivage: 'Face désarchivée avec succès.',
      faceDeleted: 'Face {code} supprimée avec succès',
    },
  },
};

export const FACE_BY_BAILLEUR = {
  actions: {
    filtre: 'Filtre',
    search: 'Rechercher une face',
  },
  tab: {
    codeFace: 'Code face',
    dateMontage: 'Date montage',
    dateDemontage: 'Date demontage',
    etatFace: 'Etat montage',
    codeMateriel: 'Code matériel',
    etatMateriel: 'Etat matériel',
    baux: 'Baux',
    disposition: 'Disposition',
    typeMateriel: 'Type de matériel',
    dispositifSupport: 'Support',
    dispositifType: 'Type de dispositif',
    adresse: 'Adresse',
    face_motif_non_com: 'Non commercialisable',
    archive: 'Archivée',
    affectation: 'Affectation',
  },
};

export const REMPLACEMENT_PRODUIT_FACE = {
  title: 'Remplacer le produit de la face "{code}"',
  breadcrumb: {
    remplacer: 'Remplacer',
  },
  actions: {
    remplacer: 'Lier',
  },
  tabs: {
    reference: 'Référence',
    libelle: 'Libellé',
    adresse: 'Adresse',
    codePostal: 'CP',
    ville: 'Ville',
    departement: 'Département',
    agglomeration: 'Agglomération',
    format: 'Format',
    materiel: 'Matériel',
    support: 'Support',
    motif: 'Motif non com.',
  },
  filtre: {
    reference: 'Référence(s)',
    libelle: 'Libellé(s)',
    ville: 'Ville(s)',
    departement: 'Département(s)',
    format: 'Format(s)',
    materiel: 'Matériel(s)',
    support: 'Support(s)',
    agglomeration: 'Agglomération(s)',
    codePostal: 'Code(s) postal',
    adresses: 'Adresse(s)',
  },
  popUpRemplacement: {
    title: 'Etes-vous sûr de vouloir lier le produit face "{codeProduit}" à la face patrimoniale "{codeFace}"',
  },
  succes: {
    replace: 'Le produit face a été remplacée avec succès',
  },
};
